import { useLocation, useNavigate } from '@solidjs/router'
import { type JSX, Show, createEffect, onMount } from 'solid-js'
import { employeeStore, resolveEmployeeRedirect } from '../../stores/employee.store'
import { RouteSkeleton } from './RouteSkeleton'

interface EmployeeRouteGuardProps {
  children: JSX.Element
}

export function EmployeeRouteGuard(props: EmployeeRouteGuardProps) {
  const navigate = useNavigate()
  const location = useLocation()

  onMount(() => {
    void employeeStore.load()
  })

  createEffect(() => {
    if (employeeStore.isLoading || employeeStore.isAuthenticated) {
      return
    }
    void resolveEmployeeRedirect(location.pathname + location.search).then((dest) => {
      if (dest) {
        navigate(dest, { replace: true })
      }
    })
  })

  const isReady = () => !employeeStore.isLoading && employeeStore.isAuthenticated

  return (
    <Show when={isReady()} fallback={<RouteSkeleton />}>
      {props.children}
    </Show>
  )
}
